import type { FormInstance } from 'antd'
import { FORM_ERROR_SCROLL_OPTIONS } from '@/const/form.ts'

/** 将提交 DTO 的校验路径映射回可见的订单表单字段。 */
export function getOrderFormIssuePath(path: readonly PropertyKey[]): Array<string | number> {
  const name = path.filter((key): key is string | number => typeof key !== 'symbol')
  if (name[0] === 'orderGroup') {
    let field = 'orderGroupMode'
    if (name[1] === 'name') {
      field = 'orderGroupName'
    } else if (name[1] === 'id') {
      field = 'orderGroupId'
    }
    return [field]
  }
  if (name[0] === 'startAt' || name[0] === 'endAt') {
    return ['period']
  }
  if (name[0] === 'roomId') {
    return ['siteId']
  }
  if (name[0] === 'services') {
    name[0] = 'items'
  }
  const enterpriseIndex = name.indexOf('enterpriseSelection')
  return enterpriseIndex < 0 ? name : name.slice(0, enterpriseIndex + 1)
}

export function showOrderFormErrors(
  form: FormInstance,
  issues: ReadonlyArray<{ path: readonly PropertyKey[]; message: string }>
) {
  const fields: Array<{ name: Array<string | number>; errors: string[] }> = []
  for (const issue of issues) {
    const name = getOrderFormIssuePath(issue.path)
    if (!name.length) {
      continue
    }
    const existing = fields.find(
      (field) => field.name.length === name.length && field.name.every((key, i) => key === name[i])
    )
    if (existing) {
      existing.errors.push(issue.message)
    } else {
      fields.push({ name, errors: [issue.message] })
    }
  }
  form.setFields(fields)
  if (fields[0]) {
    form.scrollToField(fields[0].name, FORM_ERROR_SCROLL_OPTIONS)
  }
}
